<template>
    <b-modal id="show-barcode-scanner" class="show-barcode-scanner" ref="modal" :title="dialog_title" hide-footer>
        <div class="row form-group">
            <div class="col">
                <barcode-scanner :source="stream" @bcs-started="isScanning = true" @bcs-stopped="isScanning = false"
                    @bcs-scanned="submit" rate="50%" @bcs-error="showError" mask-css="scan-area">
                </barcode-scanner>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            stream: null,
            isScanning: false,
        }
    },
    computed: {
        dialog_title() {
            return 'Escanear Código de Barras';
        },
        ...mapGetters(['msgwindow', 'clinic'])
    },
    methods: {
        show() {
            this.$refs.modal.show();
            this.setupVideo();
        },
        submit(barcodes) {
            if (barcodes.length) {
                this.$refs.modal.hide();
                this.$emit('submit', barcodes[0].rawValue);
                this.stream.getTracks().forEach(function (track) {
                    track.stop();
                });
                this.stream = null;
            }
        },
        showError(error) {
            this.msgwindow.error(error);
        },
        setupVideo() {
            if (navigator.mediaDevices.getUserMedia) {
                let that = this;
                navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
                    .then(function (stream) {
                        that.stream = stream;
                    })
                    .catch(function (error) {
                        console.log("Something went wrong!", error);
                    });
            }
        }
    }
}
</script>

<style lang="scss">
#show-barcode-scanner {
    .scan-area {
        left: 25%;
        top: 15%;
        width: 50%;
        height: 60%;
        box-shadow: 0 0 0 10000px rgba(0, 0, 0, 0.4);
        border: red solid 2px;

        &::after {
            content: '';
            display: block;
            height: 2px;
            width: 100%;
            position: absolute;
            top: calc(50% - 1px);
            left: 0;
            background-color: red;
        }
    }

    .scan-area.detected {
        border: rgb(128, 255, 128) solid 3px;
    }
}
</style>
